// --- Conteúdo FINAL: assets/calculadora-tabela.js (Seta Cima = Maior Valor) ---

(function() {
  document.addEventListener('DOMContentLoaded', () => {
    
    // --- 1. SELETORES E INICIALIZAÇÃO ---
    const inputCustoKwh = document.querySelector('[id^="custoEnergia-"]') || document.getElementById('custo-kwh-input');
    const tabelaProdutos = document.getElementById('comparative-mining-table-js');

    if (!tabelaProdutos) return;

    // Salva a ordem original
    const tbody = tabelaProdutos.querySelector('tbody');
    const originalRows = Array.from(tbody.querySelectorAll('.product-row-js')); 

    // --- 2. TOOLTIP ---
    const tooltip = document.createElement('div');
    tooltip.className = 'mining-tooltip';
    tooltip.innerHTML = 'Carregando...';
    document.body.appendChild(tooltip);

    // --- 3. DADOS API ---
    const apiUrl = 'https://proxy-cripto-br.vercel.app/api/crypto-data';
    let dadosCripto = null;
    let custoKwhGlobal = 0;

    const MAPA_NOMES = {
      'bch': 'bitcoincash', 'bitcoin-cash': 'bitcoincash',
      'quai': 'quai',
      'litecoin': 'litecoin', 'dogecoin': 'dogecoin',
      'bitcoin': 'bitcoin', 'kaspa': 'kaspa'
    };

    // --- 4. REGRAS DE CÁLCULO ---
    const COIN_RULES = {
        'bitcoin': (h, d) => calcSha256(h, d.redes.bitcoin, d.precos.bitcoin, 'Bitcoin'),
        'bitcoincash': (h, d) => calcSha256(h, d.redes.bitcoincash, d.precos.bitcoincash, 'BCH'),
        'kaspa': (h, d) => {
          const r = d.redes.kaspa, p = d.precos.kaspa;
          const c = (h / r.dificuldade) * r.recompensa_bloco * 86400;
          return { val: c * p, qtd: c, nome: 'KASPA' };
        },
        'quai': (h, d, isScrypt) => {
            // 1. Seleciona a rede (Scrypt ou SHA)
            const rQuai = isScrypt ? d.redes.quai.scrypt : d.redes.quai.sha256;
            
            // Segurança
            if (!rQuai) return { val: 0, qtd: 0, nome: 'QUAI (N/A)' };

            const preco = d.precos.quai || 0;
            const redeHashrate = rQuai.hashrate_rede || 1; 
            
            // 2. Lê o tempo real da API (ou usa 1.3s se falhar)
            const tempoBloco = rQuai.tempo_bloco || 1.3;

            // 3. Calcula blocos diários com precisão
            const blocosPorDia = 86400 / tempoBloco;
            const emissaoDiaria = blocosPorDia * rQuai.recompensa_bloco;

            const minhaFatia = h / redeHashrate;
            const minhasMoedas = emissaoDiaria * minhaFatia;
            
            return { 
                val: minhasMoedas * preco, 
                qtd: minhasMoedas, 
                nome: 'QUAI' 
            };
        },
        'litecoin': (h, d) => calcScrypt(h, d),
        'dogecoin': (h, d) => calcScrypt(h, d)
    };

    function calcSha256(hash, rede, preco, nome) {
        const coins = (hash * rede.recompensa_bloco * 86400) / (rede.dificuldade * 4294967296);
        return { val: coins * preco, qtd: coins, nome: nome };
    }

    function calcScrypt(hash, dados) {
        const rLtc = dados.redes.litecoin, pLtc = dados.precos.litecoin;
        const rDoge = dados.redes.dogecoin, pDoge = dados.precos.dogecoin;
        const ltcC = (hash * rLtc.recompensa_bloco * 86400) / (rLtc.dificuldade * 4294967296);
        const dogeC = (hash * rDoge.recompensa_bloco * 86400) / (rDoge.dificuldade * 4294967296);
        return { val: (ltcC * pLtc) + (dogeC * pDoge), qtd: ltcC, nome: 'LTC + DOGE', isCombo: true, qtdSecundaria: dogeC };
    }

    // --- 5. LÓGICA PRINCIPAL ---

    async function iniciar() {
        setLoadingState();
        try {
            const res = await fetch(apiUrl);
            if (!res.ok) throw new Error('Falha API');
            dadosCripto = await res.json();
            recalcularTudo();
        } catch (err) {
            console.error(err);
            setErrorState();
        }
    }

    function recalcularTudo() {
        if (!dadosCripto) return;
        if (inputCustoKwh) custoKwhGlobal = parseFloat(inputCustoKwh.value.replace(',', '.')) || 0;

        const linhas = tabelaProdutos.querySelectorAll('tbody .product-row-js');
        linhas.forEach(row => processarLinha(row));
        reaplicarOrdenacao();
    }

    function processarLinha(row) {
        const elEnergia = row.querySelector('.col-energia');
        const elRendimento = row.querySelector('.col-rendimento');
        
        const consumoW = parseFloat(row.dataset.consumo) || 0;
        const hashrateBruto = parseFloat(row.dataset.hashrate) || 0;
        const moedasString = (row.dataset.moeda || "").toLowerCase();

        // 1. Energia
        const custoDia = (consumoW / 1000) * custoKwhGlobal * 24;
        const custoMes = custoDia * 30;
        
        if(elEnergia) elEnergia.innerHTML = `<span style="color:#ff4500">${formatarReais(custoMes)} /mês</span>`;
        row.dataset.energia = custoMes; 

        // 2. Moedas
        let listaMoedas = [];
        moedasString.split(',').forEach(m => {
            let k = m.trim(); 
            if(k) { let mapK = MAPA_NOMES[k] || k; if(!listaMoedas.includes(mapK)) listaMoedas.push(mapK); }
        });

        const isScrypt = listaMoedas.includes('litecoin') || listaMoedas.includes('dogecoin');

        // 3. Best Case
        let melhorLucro = -Infinity;
        let melhorDados = null;
        row.dadosCalculados = {}; 

        listaMoedas.forEach(key => {
            let h = hashrateBruto * (isScrypt ? 1e9 : 1e12);
            if (key === 'litecoin' || key === 'dogecoin') h = hashrateBruto * 1e9;

            const regra = COIN_RULES[key];
            if (regra) {
                const res = regra(h, dadosCripto, isScrypt);
                const liqMes = (res.val - custoDia) * 30;
                
                row.dadosCalculados[key] = {
                    lucroMes: liqMes, qtdMes: res.qtd * 30, nomeDisplay: res.nome,
                    isCombo: res.isCombo, qtdSecundaria: (res.qtdSecundaria||0)*30
                };

                if (liqMes > melhorLucro) { melhorLucro = liqMes; melhorDados = row.dadosCalculados[key]; }
            }
        });

        // --- NOVO: REORDENAR ÍCONES (Maior Lucro -> Menor Lucro) ---
        const containerMoedas = row.querySelector('.col-moeda div');
        if (containerMoedas) {
            const icones = Array.from(containerMoedas.querySelectorAll('.coin-icon-js'));
            
            icones.sort((a, b) => {
                const hA = a.dataset.coinHandle;
                const hB = b.dataset.coinHandle;
                
                const keyA = MAPA_NOMES[hA] || hA;
                const keyB = MAPA_NOMES[hB] || hB;
                
                const lucroA = row.dadosCalculados[keyA] ? row.dadosCalculados[keyA].lucroMes : -Infinity;
                const lucroB = row.dadosCalculados[keyB] ? row.dadosCalculados[keyB].lucroMes : -Infinity;
                
                // 1. Critério Principal: Lucro (Maior para Menor)
                const diff = lucroB - lucroA;

                // 2. Critério de Desempate (Tie-Breaker)
                // Se a diferença de lucro for insignificante (menor que 1 centavo), são iguais.
                if (Math.abs(diff) < 0.01) {
                    // Então ordenamos pelo Nome (Handle) para manter fixo.
                    // hB.localeCompare(hA) fará ordem alfabética inversa (Litecoin antes de Dogecoin)
                    // Se preferir Doge antes, use hA.localeCompare(hB)
                    return hB.localeCompare(hA); 
                }
                
                return diff;
            });

            // Reinsere os ícones na nova ordem
            icones.forEach(icon => containerMoedas.appendChild(icon));
        }
        // -----------------------------------------------------------

        // 4. Atualiza HTML e DATASET
        const elRoi = row.querySelector('.col-roi'); // Pega a célula do ROI

        if (melhorDados && elRendimento) {
            const cor = melhorDados.lucroMes >= 0 ? '#2ecc71' : '#ff4444';
            const lucroDia = melhorDados.lucroMes / 30;
            elRendimento.innerHTML = `<strong style="color:${cor}; font-size:1.1em;">${formatarReais(melhorDados.lucroMes)} /mês</strong><br><small style="color:${cor};">${formatarReais(lucroDia)} /dia</small>`;
            row.dataset.lucro = melhorDados.lucroMes; 

            // --- CÁLCULO DO ROI ADICIONADO AQUI ---
            // --- CÁLCULO DO ROI COM PROTEÇÃO ---
            const precoEquipamento = parseFloat(row.dataset.price) / 100; // Shopify envia em centavos

            if (melhorDados && melhorDados.lucroMes > 0.01) { // Verifica se há lucro real
                const mesesROI = precoEquipamento / melhorDados.lucroMes;
                
                if (elRoi) {
                    elRoi.innerText = mesesROI > 100 ? '+100 meses' : `${mesesROI.toFixed(1)} meses`;
                }
                row.dataset.roi = mesesROI; 
            } else {
                // Se o lucro for 0 ou negativo, o ROI é impossível/infinito
                if (elRoi) elRoi.innerText = (melhorDados && melhorDados.lucroMes <= 0) ? 'Impossível' : '--';
                row.dataset.roi = 999999; 
            }
            // --------------------------------------

        } else {
            if(elRendimento) elRendimento.innerText = '--';
            if(elRoi) elRoi.innerText = '--';
            row.dataset.lucro = -999999999; 
            row.dataset.roi = 999999;
        }

        ativarHoverIcones(row);
    }

    // --- 6. SISTEMA DE ORDENAÇÃO (INVERTIDO: ASC = Maior para Menor) ---
    
    const sortableHeaders = tabelaProdutos.querySelectorAll('thead th.sortable');
    let currentSort = { key: null, direction: 'default' };

    sortableHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const key = header.dataset.sortKey; 
            
            // Ciclo: default -> asc (1º clique, seta cima) -> desc (2º clique, seta baixo) -> default
            let newDir = 'asc'; // 1º Clique: Seta Cima

            if (currentSort.key === key) {
                if (currentSort.direction === 'asc') newDir = 'desc'; // 2º Clique: Seta Baixo
                else if (currentSort.direction === 'desc') newDir = 'default';
            }

            // Atualiza visual
            sortableHeaders.forEach(h => h.classList.remove('sort-asc', 'sort-desc'));
            if (newDir !== 'default') {
                header.classList.add(`sort-${newDir}`);
            }

            currentSort = { key: key, direction: newDir };
            executarOrdenacao(key, newDir);
        });
    });

    function executarOrdenacao(key, direction) {
        const rowsNow = Array.from(tbody.querySelectorAll('.product-row-js'));
        
        if (direction === 'default') {
            originalRows.forEach(r => tbody.appendChild(r));
            return;
        }

        rowsNow.sort((a, b) => {
            let valA = parseFloat(a.dataset[key]) || 0;
            let valB = parseFloat(b.dataset[key]) || 0;

            // AQUI ESTÁ A INVERSÃO SOLICITADA:
            // Se for 'asc' (Seta Cima), ordenamos B - A (Maior para Menor)
            if (direction === 'asc') return valB - valA; 
            
            // Se for 'desc' (Seta Baixo), ordenamos A - B (Menor para Maior)
            return valA - valB; 
        });

        rowsNow.forEach(r => tbody.appendChild(r));
    }

    function reaplicarOrdenacao() {
        if (currentSort.key && currentSort.direction !== 'default') {
            executarOrdenacao(currentSort.key, currentSort.direction);
        }
    }

    // --- 7. TOOLTIP ---
    function ativarHoverIcones(row) {
        row.querySelectorAll('.coin-icon-js').forEach(icon => {
            icon.onmouseenter = (e) => mostrarTooltip(e, row);
            icon.onmouseleave = esconderTooltip;
            icon.onmousemove = moverTooltip;
        });
    }

    function mostrarTooltip(e, row) {
        const handle = e.target.dataset.coinHandle;
        // Pega os dados calculados daquela moeda específica
        const dados = row.dadosCalculados ? row.dadosCalculados[MAPA_NOMES[handle]||handle] : null;
        
        if (!dados) return;

        let txt = `${dados.qtdMes.toFixed(4)} ${dados.nomeDisplay}`;
        if (dados.isCombo) txt = `${dados.qtdMes.toFixed(2)} LTC + ${dados.qtdSecundaria.toFixed(0)} DOGE`;

        // --- A MUDANÇA ESTÁ AQUI ---
        // Se o lucro for maior ou igual a zero, usa VERDE (#2ecc71).
        // Se for negativo, usa VERMELHO (#ff4444).
        const corValor = dados.lucroMes >= 0 ? '#2ecc71' : '#ff4444';

        tooltip.innerHTML = `<strong>${dados.nomeDisplay}</strong>
            <div class="tooltip-values" style="color: ${corValor}">
                ${formatarReais(dados.lucroMes)} 
                <small style="color:#fff; font-weight:normal">Liq./mês</small>
            </div>
            <div class="tooltip-coin-amount">Est: ${txt}</div>`;
        
        tooltip.classList.add('visible');
        moverTooltip(e);
    }

    function esconderTooltip() { tooltip.classList.remove('visible'); }
    function moverTooltip(e) { tooltip.style.left = (e.clientX + 15) + 'px'; tooltip.style.top = (e.clientY + 15) + 'px'; }
    function formatarReais(v) { return `R$ ${v.toFixed(2).replace('.', ',')}`; }
    function setLoadingState() { document.querySelectorAll('tbody .col-rendimento').forEach(el => el.innerHTML = '<span style="color:#888;size:10px">...</span>'); }
    function setErrorState() { document.querySelectorAll('tbody .col-rendimento').forEach(el => el.innerText = 'Erro'); }

    if (inputCustoKwh) inputCustoKwh.addEventListener('input', recalcularTudo);
    iniciar();
  });
})();